// Coupe CH Tournament Data — 1, 2, 3 Mai 2026
// Aréna unique : CCSSJ (Centre de la Culture et du Sport de Sainte-Julie)
// Adresse : 201, boul. Armand-Frappier, Sainte-Julie (Québec) J3E 0C7
// 3 glaces : Glace Hamelin, Glace Letang, Glace Bâtisseurs

export const TOURNAMENT_INFO = {
  name: "COUPE CH",
  edition: "Édition 2026",
  dates: "1, 2 et 3 MAI 2026",
  tagline: "UN TOURNOI. UNE PASSION.",
  subtagline: "DES SOUVENIRS POUR LA VIE",
  thanks: "MERCI À TOUTES LES ÉQUIPES ET BON TOURNOI À TOUS !",
  venue: {
    name: "CCSSJ",
    longName: "Centre de la Culture et du Sport de Sainte-Julie",
    address: "201, boul. Armand-Frappier",
    city: "Sainte-Julie (Québec) J3E 0C7",
    full: "201, boul. Armand-Frappier, Sainte-Julie (Québec) J3E 0C7",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=201+boulevard+Armand-Frappier+Sainte-Julie+Quebec+J3E+0C7",
  },
  ices: ["Glace Hamelin", "Glace Letang", "Glace Bâtisseurs"],
  categories: ["2017", "2018"],
};

export const TEAMS = [
  { id: "expos", name: "Expos", category: "2017" },
  { id: "lions", name: "Lions", category: "2017" },
  { id: "hawks-turcot", name: "Hawks Turcot", category: "2017" },
  { id: "hawks-halliee", name: "Hawks Hallée", category: "2017" },
  { id: "ice-tigers-giroux", name: "Ice Tigers Giroux", category: "2017" },
  { id: "ice-tigers-calgaro", name: "Ice Tigers Calgaro-Hamel", category: "2017" },
  { id: "kraken", name: "Kraken", category: "2018" },
  { id: "hawks", name: "Hawks", category: "2018" },
  { id: "wolf-pack", name: "Wolf Pack", category: "2018" },
  { id: "ice-tigers-gilbert", name: "Ice Tigers Gilbert", category: "2018" },
  { id: "ice-tigers-varennes", name: "Ice Tigers Varennes", category: "2018" },
];

// "Des Bâtisseurs" → "Glace Bâtisseurs", "Hamelin" → "Glace Hamelin"
export const SCHEDULE = [
  // VENDREDI 1 MAI
  { day: "Vendredi 1 Mai", num: 1, time: "8h30", ice: "Glace Bâtisseurs", category: "2017", away: "Expos", home: "Lions" },
  { day: "Vendredi 1 Mai", num: 2, time: "9h30", ice: "Glace Bâtisseurs", category: "2018", away: "Kraken", home: "Hawks" },
  { day: "Vendredi 1 Mai", num: 3, time: "10h30", ice: "Glace Bâtisseurs", category: "2017", away: "Hawks Turcot", home: "Ice Tigers Giroux" },
  { day: "Vendredi 1 Mai", num: 4, time: "12h10", ice: "Glace Hamelin", category: "2018", away: "Ice Tigers Gilbert", home: "Wolf Pack" },
  { day: "Vendredi 1 Mai", num: 5, time: "13h10", ice: "Glace Hamelin", category: "2018", away: "Kraken", home: "Ice Tigers Varennes" },
  { day: "Vendredi 1 Mai", num: 6, time: "13h30", ice: "Glace Bâtisseurs", category: "2017", away: "Ice Tigers Calgaro-Hamel", home: "Lions" },
  { day: "Vendredi 1 Mai", num: 7, time: "14h30", ice: "Glace Bâtisseurs", category: "2017", away: "Hawks Hallée", home: "Ice Tigers Giroux" },
  { day: "Vendredi 1 Mai", num: 8, time: "15h40", ice: "Glace Hamelin", category: "2017", away: "Expos", home: "Hawks Turcot" },
  { day: "Vendredi 1 Mai", num: 9, time: "17h30", ice: "Glace Bâtisseurs", category: "2018", away: "Ice Tigers Varennes", home: "Wolf Pack" },
  { day: "Vendredi 1 Mai", num: 10, time: "18h30", ice: "Glace Bâtisseurs", category: "2018", away: "Ice Tigers Gilbert", home: "Hawks" },
  { day: "Vendredi 1 Mai", num: 11, time: "19h30", ice: "Glace Bâtisseurs", category: "2017", away: "Hawks Hallée", home: "Ice Tigers Calgaro-Hamel" },
  // SAMEDI 2 MAI
  { day: "Samedi 2 Mai", num: 12, time: "12h30", ice: "Glace Bâtisseurs", category: "2018", away: "Ice Tigers Gilbert", home: "Ice Tigers Varennes" },
  { day: "Samedi 2 Mai", num: 13, time: "12h50", ice: "Glace Letang", category: "2018", away: "Wolf Pack", home: "Kraken" },
  { day: "Samedi 2 Mai", num: 14, time: "13h30", ice: "Glace Bâtisseurs", category: "2017", away: "Ice Tigers Giroux", home: "Ice Tigers Calgaro-Hamel" },
  { day: "Samedi 2 Mai", num: 15, time: "14h30", ice: "Glace Bâtisseurs", category: "2017", away: "Hawks Hallée", home: "Expos" },
  { day: "Samedi 2 Mai", num: 16, time: "15h30", ice: "Glace Bâtisseurs", category: "2017", away: "Lions", home: "Hawks Turcot" },
  { day: "Samedi 2 Mai", num: 17, time: "16h30", ice: "Glace Bâtisseurs", category: "2018", away: "Hawks", home: "Wolf Pack" },
  { day: "Samedi 2 Mai", num: 18, time: "17h30", ice: "Glace Bâtisseurs", category: "2018", away: "Kraken", home: "Ice Tigers Gilbert" },
  { day: "Samedi 2 Mai", num: 19, time: "18h10", ice: "Glace Hamelin", category: "2017", away: "Hawks Hallée", home: "Lions" },
  { day: "Samedi 2 Mai", num: 20, time: "18h30", ice: "Glace Bâtisseurs", category: "2017", away: "Expos", home: "Ice Tigers Giroux" },
  { day: "Samedi 2 Mai", num: 21, time: "19h10", ice: "Glace Hamelin", category: "2017", away: "Ice Tigers Calgaro-Hamel", home: "Hawks Turcot" },
  { day: "Samedi 2 Mai", num: 22, time: "19h30", ice: "Glace Bâtisseurs", category: "2018", away: "Ice Tigers Varennes", home: "Hawks" },
  // DIMANCHE 3 MAI
  { day: "Dimanche 3 Mai", num: 23, time: "9h00", ice: "Glace Bâtisseurs", category: "2018", away: "Pool A position 3", home: "Pool A position 2", phase: "Demi-finale 2018" },
  { day: "Dimanche 3 Mai", num: 24, time: "10h00", ice: "Glace Bâtisseurs", category: "2017", away: "Pool A position 4", home: "Pool A position 1", phase: "Demi-finale 2017" },
  { day: "Dimanche 3 Mai", num: 25, time: "11h00", ice: "Glace Bâtisseurs", category: "2017", away: "Pool A position 3", home: "Pool A position 2", phase: "Demi-finale 2017" },
  { day: "Dimanche 3 Mai", num: 26, time: "12h00", ice: "Glace Bâtisseurs", category: "2017", away: "Pool B position 6", home: "Pool B position 5", phase: "Finale D3 2017" },
  { day: "Dimanche 3 Mai", num: 27, time: "14h15", ice: "Glace Bâtisseurs", category: "2018", away: "Pool B position 5", home: "Pool B position 4", phase: "Finale D3 2018" },
  { day: "Dimanche 3 Mai", num: 28, time: "15h30", ice: "Glace Bâtisseurs", category: "2018", away: "Gagnant de la 23", home: "1ère position", phase: "Finale D2 2018" },
  { day: "Dimanche 3 Mai", num: 29, time: "16h30", ice: "Glace Bâtisseurs", category: "2017", away: "Gagnant de la 25", home: "Gagnant de la 24", phase: "Finale D2 2017" },
];

// Pool composition rules (sizes), based on the official schedule:
// 2017 (6 équipes) : Pool A = top 4, Pool B = positions 5-6
// 2018 (5 équipes) : Pool A = top 3, Pool B = positions 4-5
export const POOL_SIZES = {
  "2017": { A: 4, B: 2 },
  "2018": { A: 3, B: 2 },
};

// Placeholder lists (kept for reference / not used to seed standings; pools are derived live)
export const POOLS = {
  "2017": {
    A: ["Pool A pos 1", "Pool A pos 2", "Pool A pos 3", "Pool A pos 4"],
    B: ["Pool B pos 5", "Pool B pos 6"],
  },
  "2018": {
    A: ["Pool A pos 1", "Pool A pos 2", "Pool A pos 3"],
    B: ["Pool B pos 4", "Pool B pos 5"],
  },
};

// Hosted user-uploaded images
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/4oce7y2s_IMG_7052.jpeg",
  logo_transparent: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/e3yf1kv6_BC8C5FB9-9D49-4566-BB81-2F5C5764AE0F.png",
  bear_logo: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/d2q42a4l_IMG_7039.png",
  kids_red: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/hyyxdq9q_IMG_7051.jpeg",
  team_ice: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/v2wocoth_IMG_7043.jpeg",
  bench: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/52kqa0az_IMG_7045.jpeg",
  dressing_room: "https://customer-assets.emergentagent.com/job_ice-league-hub-1/artifacts/lfm8qanc_IMG_7049.jpeg",
};
